import React, { useContext, useState } from "react";
import { useUbigeo } from "../../hooks/useUbigeo";
import { FormContext } from "../../contexts/FormContext";


export const PagoForm = ({ onSubmit }) => {
    /*FORM DATA CONTEXT*/
    const { formData, updateField } = useContext(FormContext);
    const handleChangeF = ({ target }) => {
        //console.log('handleChangeFxxx' ,target.value,target.options[target.selectedIndex].text)
        updateField(target.name, target.value);
    };
    const handleChangeFcbo = ({ target }) => {
        //console.log('handleChangeFxxx' ,target.name,target.options[target.selectedIndex].text)
        updateField(target.name, target.options[target.selectedIndex].text);
    };

    /*FORM DATA CONTEXT*/
    const [tipoDocumento, setTipoDocumento] = useState("")

    const {
        ubigeoData,
        departamento,
        setDepartamento,
        provincia,
        setProvincia,
        distrito,
        setDistrito,
    } = useUbigeo()

    const [errors, setErrors] = useState({})
    const [telefono, setTelefono] = useState("")

    const validateField = (name, value) => {
        let error = "";
        switch (name) {
            case "nombre":
            case "apellidos":
                if (!/^[a-zA-Z\s]+$/.test(value)) {
                    error = "Solo se permiten letras y espacios."
                }
                break
            case "email":
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    error = "Correo electrónico no válido."
                }
                break
            case "telefono":
                const cleanValue = value.replace(/\s+/g, "");
                if (!/^\d{9}$/.test(cleanValue)) {
                    error = "El teléfono debe ser un número válido de 9 dígitos.";
                }
                break
            case "dni":
                if (!/^\d{8,12}$/.test(value)) {
                    error = "El DNI o CE debe tener 8 u 12 dígitos."
                }
                break
            case "ruc":
                if (value && !/^\d{11}$/.test(value)) {
                    error = "El RUC debe tener 11 dígitos."
                }
                break
            default:
                break
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: error }))
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === "telefono") {
            let newValue = value.replace(/[^0-9]/g, "");
            if (newValue.length > 9) {
                newValue = newValue.slice(0, 9);
            }
            setTelefono(newValue);
            validateField(name, newValue);
        } else {
            validateField(name, value);
        }
    }

    return (
        <div className="pago-form font9 font10-5 font400">
            {/*<form onSubmit={onSubmit} method="POST">*/}
            <form method="POST">
                <div className="form-group" placeholder="País / Región:">
                    {/* <label className="color-A4A4A4" htmlFor="pais">
                        País / Región:
                    </label> */}
                    <select id="pais" name="pais">
                        <option value="peru">Perú</option>
                    </select>
                </div>
                <div className="box-nombre-apellidos">
                    <div className="form-group ancho-form">
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            placeholder="Nombre *"
                            required
                            className="font9 font10-5 color-A4A4A4"
                            //onChange={handleChange}
                            value={formData.nombre}
                            onChange={handleChangeF}
                        />
                        {errors.nombre && <span className="error-message">{errors.nombre}</span>}
                    </div>
                    <div className="form-group ancho-form">
                        <input
                            type="text"
                            id="apellidos"
                            name="apellidos"
                            placeholder="Apellidos *"
                            required
                            className="font9 font10-5 color-A4A4A4"
                            //onChange={handleChange}
                            value={formData.apellidos}
                            onChange={handleChangeF}
                        />
                        {errors.apellidos && <span className="error-message">{errors.apellidos}</span>}
                    </div>
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Correo electrónico *"
                        required
                        className="font9 font10-5 color-A4A4A4"
                        //onChange={handleChange}
                        value={formData.email}
                        onChange={handleChangeF}
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
                <div className="form-group">
                    <input
                        type="number"
                        id="ruc"
                        name="ruc"
                        maxLength="11"
                        placeholder="RUC si necesita factura"
                        className="font9 font10-5 color-A4A4A4"
                        value={formData.ruc}
                        onChange={handleChangeF}
                    />
                    {errors.ruc && <span className="error-message">{errors.ruc}</span>}
                </div>
                <div className="form-group">
                    <input
                        type="number"
                        id="dni"
                        name="dni"
                        maxLength="8"
                        placeholder="DNI o CE *"
                        required
                        className="font9 font10-5 color-A4A4A4"
                        value={formData.dni}
                        onChange={handleChangeF}
                    />
                    {errors.dni && <span className="error-message">{errors.dni}</span>}
                </div>
                <div className="form-group">
                    {!departamento && (
                        <label className="color-A4A4A4 font9 font10-5 form-label-checkout" htmlFor="departamento">
                            Departamento *
                        </label>
                    )}
                    <select
                        id="departamento"
                        name="departamento"
                        value={departamento}
                        //value={formData.departamento}
                        onChange={(e) => {
                            setDepartamento(e.target.value);
                            setProvincia("");
                            setDistrito("");
                            handleChangeFcbo(e)
                        }}
                    >
                        <option value=""></option>
                        {Object.keys(ubigeoData).map((dep) => (
                            <option key={dep} value={dep}>
                                {ubigeoData[dep].nombre}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    {!provincia && (
                        <label className="color-A4A4A4 font9 font10-5 form-label-checkout" htmlFor="provincia">
                            Provincia *
                        </label>
                    )}
                    <select
                        id="provincia"
                        name="provincia"
                        value={provincia}
                        onChange={(e) => {
                            setProvincia(e.target.value);
                            setDistrito("");
                            handleChangeFcbo(e)
                        }}
                        disabled={!departamento}
                    >
                        <option value="" hidden></option>
                        {Object.keys(ubigeoData[departamento]?.provincias || {}).map((prov) => (
                            <option key={prov} value={prov}>
                                {ubigeoData[departamento].provincias[prov].nombre}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    {!distrito && (
                        <label className="color-A4A4A4 font9 font10-5 form-label-checkout" htmlFor="distrito">
                            Distrito *
                        </label>
                    )}
                    <select
                        id="distrito"
                        name="distrito"
                        value={distrito}
                        onChange={(e) => {
                            setDistrito(e.target.value);
                            handleChangeFcbo(e)
                        }}
                        disabled={!provincia}
                    >
                        <option value="" hidden></option>
                        {(ubigeoData[departamento]?.provincias[provincia]?.distritos || []).map((dist) => (
                            <option key={dist} value={dist}>
                                {dist}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    {!tipoDocumento && (
                        <label className="color-A4A4A4 font9 font10-5 form-label-checkout" htmlFor="tipoDocumento">
                            Tipo de Documento *
                        </label>
                    )}
                    <select
                        id="tipoDocumento"
                        name="tipoDocumento"
                        value={tipoDocumento}
                        onChange={(e) => {
                            setTipoDocumento(e.target.value);
                            handleChangeFcbo(e)
                        }}
                    >
                        <option value="" hidden></option>
                        <option value="boleta">Boleta</option>
                        <option value="factura">Factura</option>
                    </select>
                </div>

                <div className="form-group">
                    <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        //value={telefono}
                        // pattern="9[0-9]{8}"
                        required
                        placeholder="Teléfono *"a
                        className="font9 font10-5 color-A4A4A4"
                        value={formData.telefono}
                        onChange={handleChangeF}
                    />
                    {errors.telefono && <span className="error-message">{errors.telefono}</span>}
                </div>
                <div className="container-100 flex-container flex-center" style={{ marginTop: '25px' }}                >
                    {/*<button type="submit" id="btn-finalizar-compra" className="color-blanco txt-semibold font15 font16-5 font-family-montserrat">
                        Guardar
                    </button>*/}
                </div>
            </form>
        </div>
    );
};